import * as React from "react";
import ITradesPoints from "src/services/interfaces/ITradesPoints";

export enum StepTypes {
  NONE,
  FIRST,
  SECOND,
  THIRD,
  FOURTH
}

export default function ProgressPoints(props: ITradesPoints) {
  const currentStep =
    props.points === 0
      ? StepTypes.NONE
      : props.points < 3
      ? StepTypes.FIRST
      : props.points >= 3 && props.points < 6
      ? StepTypes.SECOND
      : props.points >= 6 && props.points < 10
      ? StepTypes.THIRD
      : StepTypes.FOURTH;
  const getStepStatus = (type: StepTypes) => {
    let stepIndex = 0;
    Object.values(StepTypes).forEach((val, index) => {
      if (val === type) {
        stepIndex = index;
      }
    });

    let currentStepIndex = 0;
    Object.values(StepTypes).forEach((val, index) => {
      if (val === currentStep) {
        currentStepIndex = index;
      }
    });
    if (!currentStep) {
      return "";
    }
    return currentStepIndex >= stepIndex ? (currentStepIndex === stepIndex ? "current" : "completed") : "";
  };

  return (
    <div className="progress-points" data-current={currentStep}>
      <ul>
        <li data-status={getStepStatus(StepTypes.FIRST)}>
          <div>
            <span className="phase">Até 2</span>
            <span className="percentage">+0.5%</span>
          </div>
        </li>
        <li data-status={getStepStatus(StepTypes.SECOND)}>
          <div>
            <span className="phase">de 3 a 5</span>
            <span className="percentage">+1.5%</span>
          </div>
        </li>
        <li data-status={getStepStatus(StepTypes.THIRD)}>
          <div>
            <span className="phase">de 6 a 9</span>
            <span className="percentage">+3.0%</span>
          </div>
        </li>
        <li data-status={getStepStatus(StepTypes.FOURTH)}>
          <div>
            <span className="phase">10 ou +</span>
            <span className="percentage">+5.0%</span>
          </div>
        </li>
      </ul>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/welcome/black-december/ProgressPoints.tsx